import React from 'react';
import { useSearchParams } from 'react-router-dom';
import FilterSelect from '../../../shared/FilterSelect';
import { Button } from '@mui/material';
import { useGetAllSkills } from 'src/hooks/skill.hooks';
import { SkillType } from 'types';
import { Badge, Label } from 'flowbite-react';
import Select from 'react-select';

const SkillFilterInput = ({ showSelect }: { showSelect?: boolean }) => {
	const [searchParams, setSearchParams] = useSearchParams();
	const skills = JSON.parse(searchParams.get('skills') || '[]');

	const { data: skillsData, isLoading } = useGetAllSkills({
		type: SkillType.SKILL,
	});

	const options = skillsData?.skills
		?.filter(skill => skill?.skillGroupType)
		?.map(skill => ({ value: skill?._id, label: skill?.name?.replaceAll('_', ' ') }));

	return (
		<>
			{!showSelect ? (
				<FilterSelect
					arrow={false}
					active={!!skills?.length}
					placeholder={'Skills required'}
					onClose={() => {}}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'left',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'left',
					}}
				>
					{({ handlePopoverClose }) => (
						<div className="min-w-[255px] bg-white dark:bg-[#1F2A37] py-2 ml-auto">
							{options?.map((option, i) => (
								<Button
									key={i}
									sx={{
										textAlign: 'left',
										display: 'block',
										py: '8px',
										width: '100%',
										px: '18px',
										fontSize: '14px',
										fontWeight: '400',
										color: 'inherit',
										borderRadius: '0',
										textTransform: 'none',
										'&:hover': { backgroundColor: '#7777e73f' },
										backgroundColor: skills?.includes(option?.value?.toString()) ? '#7777e71b' : 'transparent',
									}}
									onClick={() => {
										// if (handlePopoverClose) handlePopoverClose();
										if (skills?.includes(option?.value?.toString())) {
											searchParams.set(
												'skills',
												JSON.stringify(skills?.filter((skill: string) => skill !== option?.value?.toString())),
											);
											setSearchParams(searchParams);
											return;
										}
										searchParams.set('skills', JSON.stringify([...skills, option?.value?.toString()]));
										setSearchParams(searchParams);
									}}
								>
									<span>{option?.label}</span>
									{skills?.includes(option?.value?.toString()) ? (
										<Badge className="rounded-[6px] font-[500] text-xs inline-flex w-fit ml-1" size="xs" color="dark">
											Selected
										</Badge>
									) : null}
								</Button>
							))}
						</div>
					)}
				</FilterSelect>
			) : (
				<div>
					<Label className="mb-1 inline-block">Skills</Label>
					<Select
						isMulti
						menuPosition="fixed"
						placeholder="Javascript"
						className="flowbite-select--md"
						classNamePrefix="flowbite-select"
						options={options}
						value={options?.filter(option => skills?.includes(option?.value?.toString()))}
						onChange={option => {
							searchParams.set('skills', JSON.stringify(option?.map((option: any) => option?.value?.toString())));
							setSearchParams(searchParams);
						}}
					/>
				</div>
			)}
		</>
	);
};

export default SkillFilterInput;
